import Combustivel from '../combustivel';
import { TipoVeiculo } from '../tipo_veiculo';
import Cor from '../cor';
import MarcaChassi from '../marcaChassi';
import MarcaModelo from '../marcaModelo';
import Uf from '../uf';

export class VeiculoInclusaoPayload {
  constructor(
    public placa: string,
    public chassiNumero: string,
    public potencia: number,
    public lotacaoSentados: number,
    public lotacaoEmPe: number,
    public possuiAr: boolean,
    public possuiSanitario: boolean,
    public possuiWifi: boolean,
    public possuiAcessibilidade: boolean,
    public renavam: number,
    public chassiAno: number,
    public carroceriaAnofabricacao: number,
    public ultAnoLicenciamento: number,
    public tipoVeiculo: TipoVeiculo,
    public cor: Cor,
    public combustivel: Combustivel,
    public anoFabricacao: number,
    public marcaChassi: MarcaChassi,
    public marcaModelo: MarcaModelo,
    public ufJurisdicao: Uf
  ) {
  }
}
